import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  remove_session,
  getWeekDayOviewList,
  addWeekDayOverview,
  updateWeekDayText,
  sortWeekDayOverview,
  getSuggestionsList,
} from "../../../functions/general";
import { toast } from "react-toastify";
import Media from "../../../components/Media";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import PDFIcon from "../../../images/PDF_file_icon.png";
import MP3Icon from "../../../images/MP3_icon.png";
import VideoOverview from "../../../components/VideoOverview";
import TextOverview from "../../../components/TextOverview";
import PDFOverview from "../../../components/PDFOverview";
import { usePermissions } from "../../../functions/usePermissions";
import Select from "react-select";

import { SortableContainer, SortableElement, arrayMove } from "react-sortable-hoc";
import SuggestionOverview from "../../../components/SuggestionOverview";
import AudioOverview from "../../../components/AudioOverview";

function WeekDayOverview(props) {
  const { hasPermission } = usePermissions();
  const { state } = useLocation();

  const navigate = useNavigate();
  const [title, setTitle] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [errors, setErrors] = React.useState("");
  const [contentType, setContentType] = React.useState("");
  const [pdf, setPdf] = React.useState("");
  const [weekDayOverviewList, setWeekDayOverviewList] = React.useState([]);
  const [videoUrl, setVideoUrl] = React.useState("https://vimeo.com/");
  const [overviewText, setOverviewText] = React.useState();
  const [fileName, setFileName] = React.useState("");
  const [fileSize, setFileSize] = React.useState("");
  const [tableDataLoading, setTableDataLoading] = React.useState(true);
  const [tabName, setTabName] = React.useState(props?.day?.overviewTabName ? props?.day?.overviewTabName : "Overview");
  const [tabNameBtnLoading, setTabNameBtnLoading] = React.useState("");
  const [showAddPDFModal, setShowAddPDFModal] = React.useState(false);

  const [showAddAudioModal, setShowAddAudioModal] = React.useState(false);
  const [audio, setAudio] = React.useState(null);

  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const [suggestionsList, setSuggestionsList] = React.useState([]);
  const [microcycles, setMicrocycles] = React.useState([]);
  useEffect(() => {
    // props.setPageTitleAndSubTitle(props?.day?.title, `Here is the details of ${props?.day?.title} !`);
    fetchData();
  }, []);

  const fetchData = (type) => {
    getWeekDayOviewList(props?.day?._id).then((res) => {
      if (res && res.status == 201) {
        setWeekDayOverviewList(res.data);
        if (type === "add") {
          let sortedArray = [];
          res?.data?.map((overview) => sortedArray.push(overview?._id));
          sortWeekDayOverview(sortedArray).then((res) => {
            if (res && res.status == 200) {
              // fetchData();
            } else if (res && res.status == 401) {
              remove_session();
              props.getLoggedInUser();
              navigate("/login");
            } else {
              toast.error("Failed to sort the list.");
            }
            setTableDataLoading(false);
          });
        }
      } else if (res && res.status == 401) {
        remove_session();
        props.getLoggedInUser();
        navigate("/login");
      } else {
      }
      setTableDataLoading(false);
    });

    getSuggestionsList().then((res) => {
      if (res && (res.status == 200 || res.status == 201)) {
        const suggestions = res?.data?.map((item) => {
          return {
            label: item?.title,
            options: item?.program?.map((item) => {
              return { value: item?._id, label: item?.type === "microcycles" ? `${item?.title} (Microcycle)` : item?.title };
            }),
          };
        });

        setSuggestionsList(suggestions);
      } else if (res && res.status == 401) {
        remove_session();
        props.getLoggedInUser();
        navigate("/login");
      } else {
      }
    });
  };

  const handleAddOverviewVideo = (e) => {
    e.preventDefault();
    if (loading) return false;
    if (validate()) {
      setLoading(true);
      const videoData = {
        title: title,
        url: videoUrl,
        text: "",
        type: contentType,
        fileSize: "",
        weekDay: props?.day,
      };
      let type = "add";
      addWeekDayOverview(videoData).then((res) => {
        if (res && res.status == 201) {
          fetchData(type);
          toast.success("Video added successfully.");
          document.getElementById("categoryModalCloseButton").click();
          setContentType("");
        } else if (res && res.status == 401) {
          remove_session();
          props.getLoggedInUser();
          navigate("/login");
        } else {
          toast.error("Failed to add video.");
        }
        setLoading(false);
      });
    }
  };
  const handleAddOverviewText = (e) => {
    e.preventDefault();
    if (loading) return false;
    if (textValidate()) {
      setLoading(true);
      const overviewTextData = {
        title: "",
        url: "",
        text: overviewText,
        type: contentType,
        fileSize: "",
        weekDay: props?.day,
      };
      let type = "add";
      addWeekDayOverview(overviewTextData).then((res) => {
        if (res && res.status == 201) {
          fetchData(type);
          toast.success("Text added successfully.");
          document.getElementById("categoryModalCloseButton").click();
          setContentType("");
        } else if (res && res.status == 401) {
          remove_session();
          props.getLoggedInUser();
          navigate("/login");
        } else {
          toast.error("Failed to add text.");
        }
        setLoading(false);
      });
    }
  };
  const handleAddSuggestedPrograms = (e) => {
    e.preventDefault();
    if (loading) return false;
    if (suggestionValidate()) {
      setLoading(true);
      const suggestedData = {
        type: contentType,
        suggestedPrograms: microcycles,
        weekDay: props?.day,
      };
      let type = "add";
      addWeekDayOverview(suggestedData).then((res) => {
        if (res && res.status == 201) {
          fetchData(type);
          toast.success("Suggestions added successfully.");
          document.getElementById("categoryModalCloseButton").click();
          setContentType("");
        } else if (res && res.status == 401) {
          remove_session();
          props.getLoggedInUser();
          navigate("/login");
        } else {
          toast.error("Failed to add suggestion.");
        }
        setLoading(false);
      });
    }
  };
  const handleAddOverviewPDF = (e) => {
    e.preventDefault();
    if (loading) return false;
    if (pdfValidate()) {
      setLoading(true);
      const overviewPDFData = {
        title: title ?? "",
        url: pdf,
        text: "",
        fileSize: fileSize,
        type: contentType,
        weekDay: props?.day,
      };
      let type = "add";
      addWeekDayOverview(overviewPDFData).then((res) => {
        if (res && res.status == 201) {
          fetchData(type);
          toast.success("PDF added successfully.");
          document.getElementById("categoryModalCloseButton").click();
          setContentType("");
        } else if (res && res.status == 401) {
          remove_session();
          props.getLoggedInUser();
          navigate("/login");
        } else {
          toast.error("Failed to add PDF.");
        }
        setLoading(false);
      });
    }
  };

  const handleAddOverviewAudio = (e) => {
    e.preventDefault();
    if (loading) return false;
    if (audioValidate()) {
      setLoading(true);
      const overviewAudioData = {
        title: title ?? "",
        url: audio,
        text: "",
        type: contentType,
        fileSize: fileSize,
        weekDay: props?.day,
      };
      let type = "add";
      addWeekDayOverview(overviewAudioData).then((res) => {
        if (res && res.status == 201) {
          fetchData(type);
          toast.success("Audio added successfully.");
          document.getElementById("categoryModalCloseButton").click();
          setContentType("");
        } else if (res && res.status == 401) {
          remove_session();
          props.getLoggedInUser();
          navigate("/login");
        } else {
          toast.error("Failed to add audio.");
        }
        setLoading(false);
      });
    }
  };

  const validate = () => {
    let errors = {
      title: "",
      videoUrl: "",
    };
    let isValid = true;
    // if (!title) {
    //   isValid = false;
    //   errors.title = "Please enter title.";
    // }
    // URL validation
    // const urlRegex = new RegExp(
    //   "(https?:\\/\\/www\\.|https?:\\/\\/|www\\.)?[a-zA-Z0-9]{2,}(\\.[a-zA-Z0-9]{2,})(\\.[a-zA-Z0-9]{2,})?\\/[a-zA-Z0-9]{2,}"
    // );
    // if (!videoUrl || !urlRegex.test(videoUrl)) {
    //   isValid = false;
    //   errors.videoUrl = "Please enter a valid URL.";
    // }
    if (!videoUrl) {
      isValid = false;
      errors.videoUrl = "Please enter URL.";
    }
    setErrors(errors);
    return isValid;
  };
  const textValidate = () => {
    let errors = {
      overviewText: "",
    };
    let isValid = true;
    if (!overviewText) {
      isValid = false;
      errors.overviewText = "Text field is required.";
    }
    setErrors(errors);
    return isValid;
  };
  const suggestionValidate = () => {
    let errors = {
      color: "",
    };
    let isValid = true;
    if (!suggestionsList) {
      isValid = false;
      errors.color = "Please select suggested programs.";
    }
    setErrors(errors);
    return isValid;
  };
  const pdfValidate = () => {
    let errors = {
      pdf: "",
    };
    let isValid = true;
    if (!pdf) {
      isValid = false;
      errors.pdf = "PDF is required.";
    }
    setErrors(errors);
    return isValid;
  };

  const audioValidate = () => {
    let errors = {
      audio: "",
    };
    let isValid = true;
    if (!audio) {
      isValid = false;
      errors.audio = "Audio is required.";
    }
    setErrors(errors);
    return isValid;
  };

  const handleSelectChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
    const selectedValues = selectedOptions.map((option) => option.value);
    setMicrocycles(selectedValues);
  };
  const tabNameHandler = () => {
    setTabNameBtnLoading(true);
    updateWeekDayText({ overviewTabName: tabName, isOverview: true }, props?.day?._id).then((res) => {
      if (res && res.status == 200) {
        toast.success("Tab name updated successfully.");
      } else if (res && res.status == 401) {
        remove_session();
        props.getLoggedInUser();
        navigate("/login");
      } else {
        toast.error("Failed to update tab name.");
      }
      setTabNameBtnLoading(false);
    });
  };

  const setImageHandler = (pdf) => {
    if (showAddAudioModal) {
      setAudio(pdf);
    } else setPdf(pdf);
  };

  const SortableItem = SortableElement(({ item, index, serialNumber }) => (
    <div className="row justify-content-center py-2">
      {item?.type === "video" && (
        <VideoOverview type={"day"} key={index} index={serialNumber} item={item} fetchData={fetchData} getLoggedInUser={props.getLoggedInUser} />
      )}
      {item?.type === "text" && (
        <TextOverview type={"day"} key={index} index={serialNumber} item={item} fetchData={fetchData} getLoggedInUser={props.getLoggedInUser} />
      )}
      {item?.type === "pdf" && (
        <PDFOverview type={"day"} key={index} index={serialNumber} item={item} fetchData={fetchData} getLoggedInUser={props.getLoggedInUser} />
      )}
      {item?.type === "suggestion" && (
        <SuggestionOverview type={"day"} key={index} index={serialNumber} item={item} fetchData={fetchData} getLoggedInUser={props.getLoggedInUser} />
      )}
      {item?.type === "audio" && (
        <AudioOverview type={"day"} key={index} index={serialNumber} item={item} fetchData={fetchData} getLoggedInUser={props.getLoggedInUser} />
      )}
    </div>
  ));

  const SortableList = SortableContainer(({ items }) => (
    <div>
      {items.map((item, index) => (
        <SortableItem key={`item-${index}`} index={index} serialNumber={index} item={item} />
      ))}
    </div>
  ));

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setTableDataLoading(true);
    // Reorder the items in weekDayOverviewList based on the drag and drop
    const reorderedList = arrayMove(weekDayOverviewList, oldIndex, newIndex);

    // Update the props or perform any other necessary actions with the reorderedList

    let sortedArray = [];
    reorderedList?.map((overview) => sortedArray.push(overview?._id));
    sortWeekDayOverview(sortedArray).then((res) => {
      if (res && res.status == 200) {
        setWeekDayOverviewList(reorderedList);
        // fetchData();
      } else if (res && res.status == 401) {
        remove_session();
        props.getLoggedInUser();
        navigate("/login");
      } else {
        toast.error("Failed to sort the list.");
      }
      setTableDataLoading(false);
    });
  };

  const modalHandler = () => {
    setContentType("");
    setTitle("");
    setVideoUrl("https://vimeo.com/");
    setOverviewText();
    setPdf("");
  };
  return (
    <>
      <div className="row justify-content-center">
        {hasPermission("edit-day-overview") && (
          <div className="form-group col-md-6">
            <label>Tab Name</label>
            <input type="text" className="form-control" placeholder="Overview" value={tabName} onChange={(e) => setTabName(e.target.value)} />
            {!tabName && <div className="text-warning font-size-12 mt-2">This field is required.</div>}
            <button className="btn btn-primary float-right btn-sm mt-4" onClick={tabNameHandler}>
              {tabNameBtnLoading && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>} Update
            </button>
          </div>
        )}
        <div className="col-12 my-4 pt-4" style={{ borderTop: "1px solid #f0f1f5" }}>
          {hasPermission("add-day-overview") && !tableDataLoading && (
            <button className="btn btn-primary float-right" data-toggle="modal" data-target="#add" onClick={modalHandler}>
              Add Overview
            </button>
          )}
        </div>
        <div className="col-12">
          {tableDataLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-black" role="status" aria-hidden="true"></div>
            </div>
          ) : (
            <>
              {weekDayOverviewList?.length > 0 ? (
                <SortableList items={weekDayOverviewList} onSortEnd={onSortEnd} useDragHandle={true} />
              ) : (
                <h3 className="text-center">No Overview found !</h3>
              )}
            </>
          )}
        </div>
      </div>
      <div className="modal fade" id="add" data-backdrop="static">
        <div className="modal-dialog" role="document">
          <div className="modal-content pb-2">
            <div className="modal-header border-0 px-3 mb-3">
              <h5 className="modal-title">Add Content</h5>
              <button type="button" className="close" data-dismiss="modal" id="categoryModalCloseButton">
                <span>&times;</span>
              </button>
            </div>
            <div className="form-group px-3">
              <label>Select Content Type</label>
              <select
                className="form-control"
                value={contentType}
                onChange={(e) => {
                  setContentType(e.target.value);
                  setFileName("");
                  setFileSize("");
                  setPdf("");
                  setAudio("");
                }}
              >
                <option value="">Select content type</option>
                <option value="video">Video</option>
                <option value="text">Text</option>
                <option value="pdf">PDF</option>
                <option value="audio">Audio</option>
                <option value="suggestion">Suggested Programs</option>
              </select>
            </div>
            {!contentType && <h4 className="text-center my-4">Please select content type first!</h4>}
            {contentType === "video" && (
              <form noValidate onSubmit={handleAddOverviewVideo}>
                <div className="form-group px-3">
                  <label>Video Title</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter video title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                  {/* {errors.title && !title && <div className="text-warning font-size-12 mt-2">{errors.title}</div>} */}
                </div>
                <div className="form-group px-3">
                  <label>Video URL</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter video URL"
                    value={videoUrl}
                    onChange={(e) => {
                      setVideoUrl(e.target.value);
                      validate();
                    }}
                  />
                  {errors.videoUrl && !videoUrl && <div className="text-warning font-size-12 mt-2">{errors.videoUrl}</div>}
                </div>
                <div className="modal-footer border-0">
                  <button type="submit" className="btn btn-primary">
                    {loading && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>} Save
                  </button>
                </div>
              </form>
            )}
            {contentType === "text" && (
              <form noValidate onSubmit={handleAddOverviewText}>
                <div className="col-md-12">
                  <CKEditor
                    editor={ClassicEditor}
                    on
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setOverviewText(data);
                    }}
                    data={overviewText}
                  />
                </div>
                {errors.overviewText && !overviewText && <div className="text-warning font-size-12 mt-2 pl-3">{errors.overviewText}</div>}

                <div className="modal-footer border-0">
                  <button type="submit" className="btn btn-primary">
                    {loading && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>} Save
                  </button>
                </div>
              </form>
            )}
            {contentType === "pdf" && (
              <form noValidate onSubmit={handleAddOverviewPDF}>
                <div className="form-group px-3">
                  <label>Title</label>
                  <input type="text" className="form-control" placeholder="Enter title" value={title} onChange={(e) => setTitle(e.target.value)} />
                  {/* {errors.title && !title && <div className="text-warning font-size-12 mt-2">{errors.title}</div>} */}
                </div>
                <div className="form-group px-3 py-4 text-center">
                  <label>{fileName ? fileName : "Upload PDF"}</label>
                  <br />
                  {pdf && (
                    <>
                      {pdf?.substr(pdf?.length - 4) === ".pdf" ? (
                        <img src={PDFIcon} className="img-fluid img-thumbnail" width="100" />
                      ) : (
                        <img src={process.env.REACT_APP_MEDIAPATH + pdf} className="img-fluid img-thumbnail" width="150" />
                      )}
                      <br />
                    </>
                  )}
                  <button
                    type="button"
                    onClick={() => {
                      setShowAddAudioModal(false);
                      setShowAddPDFModal(true);
                    }}
                    className="btn btn-primary mt-3"
                    data-toggle="modal"
                    data-target="#media"
                  >
                    Select PDF
                  </button>
                  {errors.pdf && !pdf && <div className="text-warning font-size-12 mt-2 pl-2">{errors.pdf}</div>}
                </div>
                <div className="modal-footer border-0">
                  <button type="submit" className="btn btn-primary">
                    {loading && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>} Save
                  </button>
                </div>
              </form>
            )}
            {contentType === "audio" && (
              <form noValidate onSubmit={handleAddOverviewAudio}>
                <div className="form-group px-3">
                  <label>Title</label>
                  <input type="text" className="form-control" placeholder="Enter title" value={title} onChange={(e) => setTitle(e.target.value)} />
                  {/* {errors.title && !title && <div className="text-warning font-size-12 mt-2">{errors.title}</div>} */}
                </div>
                <div className="form-group px-3 py-4 text-center">
                  <label>Upload Audio</label>
                  <br />
                  {audio && (
                    <a href={process.env.REACT_APP_MEDIAPATH + audio} target="_blank">
                      <img src={MP3Icon} className="img-fluid img-thumbnail" width="100" />
                      <br />
                      <span>{fileName}</span>
                      <br />
                    </a>
                  )}
                  <button
                    type="button"
                    onClick={() => {
                      setShowAddPDFModal(false);
                      setShowAddAudioModal(true);
                    }}
                    className="btn btn-primary mt-3"
                    data-toggle="modal"
                    data-target="#media"
                  >
                    Select Audio
                  </button>
                  {errors.audio && !audio && <div className="text-warning font-size-12 mt-2 pl-2">{errors.audio}</div>}
                </div>
                <div className="modal-footer border-0">
                  <button type="submit" className="btn btn-primary">
                    {loading && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>} Save
                  </button>
                </div>
              </form>
            )}
            {contentType === "suggestion" && (
              <form noValidate onSubmit={handleAddSuggestedPrograms}>
                <div className="col-12">
                  <div className="form-group">
                    <label>Suggested Programs</label>
                    <Select
                      // defaultValue={searchFiltersFilters}
                      isMulti
                      name="colors"
                      value={selectedOptions}
                      options={suggestionsList}
                      onChange={handleSelectChange}
                      className="basic-multi-select form-control"
                      classNamePrefix="select"
                      grouped
                      styles={{
                        option: (provided) => ({
                          ...provided,
                          paddingLeft: "30px", // Adjust the padding value as per your preference
                        }),
                        groupHeading: (provided) => ({
                          ...provided,
                          fontWeight: "bold",
                          fontSize: "14px",
                        }),
                      }}
                    />
                  </div>
                </div>

                <div className="modal-footer border-0">
                  <button type="submit" className="btn btn-primary">
                    {loading && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>} Save
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
      {(showAddPDFModal || showAddAudioModal) && <Media setFileName={setFileName} setFileSize={setFileSize} setImageHandler={setImageHandler} />}
    </>
  );
}

export default WeekDayOverview;
